import React from "react";
import { Outlet } from "react-router-dom";

function StandaloneLayout() {
  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <Outlet />
    </div>
  );
}

export default StandaloneLayout;